import dayjs from 'dayjs';

export type ShopDateItem = {
	shop_due_date?: string | null;
	revised_partner_ship_date?: string | null;
	required_partner_ship_date?: string | null;
};

export function shopDueDate(item: ShopDateItem | null | undefined): string {
	return (
		item?.shop_due_date ||
		item?.revised_partner_ship_date ||
		item?.required_partner_ship_date ||
		''
	);
}

export function ShopShipDate({
	original,
	revised,
	format = 'YYYY-MM-DD',
}: {
	original?: string | null;
	revised?: string | null;
	format?: string;
}) {
	const formattedOriginal =
		original && dayjs(original).isValid()
			? dayjs(original).format(format)
			: '';
	const formattedRevised =
		revised && dayjs(revised).isValid()
			? dayjs(revised).format(format)
			: '';

	if (!formattedRevised) {
		return <>{formattedOriginal}</>;
	}
	return (
		<span>
			<span className="line-through">{formattedOriginal}</span>{' '}
			<span className="text-red-600">{formattedRevised}</span>
		</span>
	);
}
